import { Pipe, PipeTransform } from '@angular/core';
import { ProductCatalogSource } from '../Services/products.service';

@Pipe({
  name: 'catalogClass',
  standalone: true,
})
export class CatalogClassPipe implements PipeTransform {
  transform(source: ProductCatalogSource): string {
    return source === ProductCatalogSource.CdData ? 'catalog-cddata' : 'catalog-irish';
  }
}
